export default __webpack_public_path__ + "static/media/icon-social-thumbnail.38386662.svg";